import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../context/Auth/AuthContext";
import usePlans from "../../../hooks/usePlans";

let cachedPlanResult = null;
let cachedCompanyId = null;
let cachedTimestamp = 0;

export const useConsortiumModule = () => {
  const { user } = useContext(AuthContext);
  const { getPlanCompany } = usePlans();
  const [isEnabled, setIsEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const checkModule = async () => {
      const companyId = user?.companyId || user?.company_id;
      if (!companyId) {
        if (isMounted) {
          setIsEnabled(false);
          setLoading(false);
        }
        return;
      }

      const now = Date.now();
      if (cachedCompanyId === companyId && cachedTimestamp > now - 30000 && cachedPlanResult !== null) {
        if (isMounted) {
          setIsEnabled(cachedPlanResult);
          setLoading(false);
        }
        return;
      }

      try {
        const planConfigs = await getPlanCompany(undefined, companyId);
        // Mesmo critério do backend (requireConsortiumModule): só a flag do
        // plano/add-on. Antes, businessType "consortium" ou super-admin mostravam
        // o menu para empresa sem o módulo e todas as telas respondiam 403.
        const enabled = Boolean(
          planConfigs?.plan?.useConsortiumModule ||
          user?.company?.plan?.useConsortiumModule
        );
        cachedCompanyId = companyId;
        cachedPlanResult = enabled;
        cachedTimestamp = Date.now();

        if (isMounted) {
          setIsEnabled(enabled);
          setLoading(false);
        }
      } catch (err) {
        if (isMounted) {
          setIsEnabled(false);
          setLoading(false);
        }
      }
    };

    checkModule();
    return () => {
      isMounted = false;
    };
  }, [user?.companyId, user?.company_id, user?.company?.plan?.useConsortiumModule, getPlanCompany]);

  return { isEnabled, hasConsortium: isEnabled, loading };
};

export default useConsortiumModule;
